<template>
  <v-container fluid class="qmkey-explorer-view">
    <v-data-table
      :headers="unitColumns"
      :items="units"
      item-key="uid"
      :show-select="unitColumns.length >0"
      show-expand
      hide-default-footer
      must-sort
      :loading="isLoading"
      :search="search"
      :server-items-length="unitsCount"
      :items-per-page="unitsItemsPerPage"
      :page.sync="unitsPage"
      :sortBy="unitsSortBy"
      :sortDesc="unitsSortDesc"
      :selected="table_selected"
      :value="table_selected"
      @page-count="unitsPageCount = $event"
      v-on:update:sort-by="unitsSortBy=$event; if (unitsSortBy) updateQUnitsPagination()"
      v-on:update:sort-desc="unitsSortDesc=$event; if (unitsSortBy) updateQUnitsPagination()"
      dense
      item-class="qmkey-item-row"
      :loading-text="getNoDataMessage()"
      class="qmkey-explorer-table table-contrast-expand-icon mt-0"
      :header-props="{'sort-icon': sort_icon}"
    >
           <!-- 
              :header-props="{'sort-icon': 'mdi-sort-ascending' }" 
              :header-props="{'sort-icon': sort-desc ? 'mdi-sort-descending' : 'mdi-sort-ascending'}"
           -->
      <template v-slot:[`item.current_public_version`]="{ item }"> 
        <v-icon
          small
          class="mr-2"
          :color="files[item.current_public_version.mimetype].color"
          @click="handleEvidence(item.current_public_version)"
          v-if="item.current_public_version.mimetype"
        >
          {{ files[item.current_public_version.mimetype].icon }}
        </v-icon>
      </template>
      <template v-slot:[`item.current_workflow_limit`]="{ item }">
        <span
          v-if="item.current_workflow_limit"
          v-bind:class="[new Date() >=new Date(item.current_workflow_limit)  ? 'date-plan-late' : 'date-plan-early']"
        >
          {{
            new Date(
            item.current_workflow_limit).toLocaleDateString(
              options={'dateStyle':'short'})
          }}
        </span>
      </template>
      <template v-slot:[`item.current_workflow_state`]="{ item }">
        <v-badge
          inline
          left
          :color="item.state_color"
          dot
        >
          {{ item.current_workflow_state}}
        </v-badge>
      </template>
      <!-- Actions -->
      <template v-slot:[`item.action`]="{ item }">
        <!-- Transitions -->
        <v-menu 
          open-on-hover 
          bottom 
          left 
          offset-x 
          content-class="qmkey-explorer-table-menu-contents"
        >
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on">mdi-pencil</v-icon>
          </template>
          <v-list dense>
            <v-list-item
              v-for="transition in item['transition_candidates']"
              :key="transition.id"
              @click.stop="performTransition(item, transition)"
            >
              <v-list-item-title>{{ transition.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!--
        TODO:FIXME: Download file only for bps documents. 
        -->   
        <v-btn
          small
          icon
          @click="handleEvidence(item.current_state_document)"
          v-if="item.current_state_document.value"
          :disabled="!item.current_state_document.value"
        >
          <v-icon
            small
            class="mr-2"
          >
            mdi-download
          </v-icon>
        </v-btn>
        <!-- End documents special-->
        <!-- File reports check else clause -->
        <v-menu 
          open-on-hover 
          bottom 
          left 
          offset-x
          content-class="qmkey-explorer-table-menu-contents"
          v-else
        >
          <template v-slot:activator="{ on }">
            <v-icon
              small
              class="mr-2"
              v-on="on"
            >
              mdi-file-download-outline
            </v-icon>
          </template>

          <v-list dense>
            <v-list-item
              v-for="report in item['reports']"
              :key="report.value"
              @click.stop="printItem(item, report.value)"
            >
              <v-list-item-title>{{ report.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- View PDF reports -->
        <v-menu 
          open-on-hover 
          bottom 
          left 
          offset-x
          content-class="qmkey-explorer-table-menu-contents"
        >
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on">mdi-eye-outline</v-icon>
          </template>
          <v-list dense>
            <v-list-item
              v-for="report in item['visor_pdf_reports']"
              :key="report.value"
              @click.stop="pdfViewerItem(item, report.value)"
            >
              <v-list-item-title>{{ report.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- Contacts -->
        <v-menu
          open-on-hover
          close-on-content-click
          dense
          offset-x
          left
          content-class="qmkey-explorer-table-menu-contents"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              icon
            >
              <v-icon small class="mr-2">mdi-at</v-icon>
            </v-btn>
          </template>
          <v-list dense class="overflow-y-auto" two-line>
            <v-list-item
              v-for="contact in item.contacts"
              :key="contact.value"
            >
              <v-list-item-avatar color="primary" :size="32">
                <v-img 
                  v-if="contact.photo"
                  :src="$base + contact.photo">
                </v-img>
                <span
                  v-else
                  color="primary"
                >
                  {{ contact.initials }}
                </span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="contact.title"></v-list-item-title>
                <v-list-item-subtitle v-text="contact.role"></v-list-item-subtitle>
              </v-list-item-content>
              
              <v-list-item-action>
                <v-icon
                  small
                  color="primary"
                  @click="copyToClipboard(contact.phone)"
                >
                  mdi-phone
                </v-icon>
              </v-list-item-action>
              <v-list-item-action>
                <v-icon 
                  small
                  color="primary"
                  @click="copyToClipboard(contact.email)"
                >
                  mdi-email
                </v-icon>
              </v-list-item-action>              
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- Allowed Contents -->
        <v-menu
          open-on-hover
          close-on-content-click
          dense
          offset-x
          left
          content-class="qmkey-explorer-table-menu-contents"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              icon
            >
              <v-icon small class="mr-2">mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list dense class="overflow-y-auto">
            <v-list-item
              v-for="allowed in item.allowed_content_types"
              :key="allowed.reference"
              @click.stop="performTransition(item, allowed)"
            >
              <v-list-item-content>
                <v-list-item-title v-text="allowed.readable_type"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- Custom file reports template -->
        
          <input-file-dialog
            v-if="isAdmin"
            :current_qunit="item"
            @file_choosed="printCustomReport"
          />
      </template>
      
        
      
      <!-- Expanded -->
      <template v-slot:expanded-item="{ item }">
        <td
          :colspan="unitColumns.length +1"
          class="qmkey-explorer-table-expansion-td"
        > <!-- needed to use row length -->
          <v-container fluid>
            <v-row class="qmkey-explorer-table-expansion-cont">
              <v-tabs
                v-model="tabs"
                icons-and-text
                align-with-title
                background-color="#cac8c9"
                height = 32
                class="qmkey-explorer-table-expansion-panel"
                active-class="qmkey-explorer-table-expansion-panel-active"
              >
                <v-tabs-slider style="display: none"></v-tabs-slider>
                <!-- 
                  FIXME: BP no inliine-box-data defined. 
                  Retrocompatibility.  DEPRECATED 
                -->
                <v-tab v-for="(tab,i) in item['inline_boxes']" :key="i"
                  class="qmkey-explorer-table-expansion-panel-header">
                  <div class="tab">
                    {{ tab.name }}
                  </div>
                </v-tab>
              </v-tabs>
              <v-tabs-items 
                v-model="tabs"
                class="qmkey-explorer-table-expansion-panel-contents"
              >
                <v-tab-item
                  v-for="(tab, i) in item['inline_boxes']"
                  :key="i" class="qmkey-explorer-table-expansion-panel-content"
                >
                  <!-- QUnit data -->
                  <InlineBoxData 
                    v-if="tab.type=='inline-box-data'"
                    :current_qunit="item"
                    :props="tab.props" 
                  />
                  <!--Related Qunits -->
                  <InlineBoxRelated
                    v-else-if="tab.type=='inline-box-related'"
                    :current_qunit="item"
                    :props="tab.props"
                    @form_submit="childFormSubmit(current_unit)"
                  />
                  <!-- Comunications -->
                    <inline-box-comunications
                    v-else-if="tab.type=='inline-box-comunications'"
                    :current_qunit="item" 
                    :props="tab.props" 
                    />
                  <!-- WORKFLOW -->
                  <inline-box-workflow 
                  v-else-if="tab.type=='inline-box-workflow'"
                  :current_qunit="item"
                  :props="tab.props"  />
                  <!-- Versions -->
                  <inline-box-versions
                    v-else-if="tab.type=='inline-box-documents'"
                    :current_qunit="item"
                    @download_file="handleEvidence"
                    :props="tab.props" 
                  />
                </v-tab-item>                
              </v-tabs-items>
            </v-row>
          </v-container>
        </td>
      </template>
      <!-- Pagination -->
      <template v-slot:footer>
        <q-pagination
          :max_visible_buttons="3"
          :current_page="unitsPage"
          :total_units="unitsCount"
          :allow_change_items_per_page="false"
          :items_per_page="itemsPerPage"
          :units_length="units.length"
          @page_changed="updateQUnitsPagination"
          @items_per_page_changed="updateItemsPerPage">
        </q-pagination>
      </template>
      <!-- /Pagination -->
    </v-data-table>

    <!-- Modal dialog -->
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      @close-dialog="toggle_dialog"
      @submit="process_form"
    >
    </modal-dialog-form>
    <!--  /Modal dialog -->    
    </v-container>
</template>


<script>
import QUnit from '@/api/QUnit'
import QReport from '@/api/QReportsItem'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import ExplorerHeader from './ExplorerHeader'
import DynamicForm from '@/components/DynamicForm'
 
import InlineBoxRelated from './RelatedInlineBox'
import InlineBoxData from './DataInlineBox'
import InlineBoxVersions from './VersionsInlineBox.vue'
import InlineBoxWorkflow from './WorkflowInlineBox.vue'
import InputFileDialog from './InputFileDialog.vue'
import ModalDialogForm from './ModalDialog'
import InlineBoxComunications from './InlineBoxComunications'
import QPagination from '@/components/QPagination'

export default {
  name: 'Table',
  components: { 
    ViewTitle,
    ExplorerHeader,
    InlineBoxRelated,
    InlineBoxData,
    InlineBoxVersions,
    InlineBoxWorkflow,
    DynamicForm,
    InputFileDialog,
    ModalDialogForm,
    InlineBoxComunications,
    QPagination
  },
  data() {
    return {
      unitsPage: 1,
      unitsPageCount: 0,
      itemsPerPageArray: [10],
      itemsPerPage: 10,
      unitsSortBy: 'current_workflow_limit',
      unitsSortDesc: false,
      search: '',
      editedItem: {},
      can_create_units: false,
      creation_fields_to_collect: [],
      creation_form_error_message: '',
      fields_to_collect: [],
      show_transitions: true,
      current_transition: {},
      form_error_message: '',
      subPane: 'tree',
      jsdata: '',
      edjsdata: '',
      isTyping: false,
      maximized: {
        fields: false,
        relations: true,
        evidences: false,
        workflow: false,
      },
      selected: [],
      workflowFields: [
        { value: 'transition', text: 'Transition' },
        { value: 'state_in', text: 'Previous State' },
        { value: 'state_out', text: 'Next State' },
        { value: 'transition_time', text: 'Execution Time' },
        { value: 'transition_user', text: 'Executed By' },
        { value: 'destination_responsible', text: 'Responsible' },
        { value: 'destination_limit', text: 'Limit' },
      ],
      relationFields: [
        { value: 'title', text: 'Title', sortable: true },
        { value: 'current_workflow_responsible', text: 'Responsible' },
        { value: 'current_workflow_limit', text: 'Limit' },
        { value: 'current_workflow_state', text: 'State' },
        { value: 'readable_type', text: 'Type', sortable: true },
        { value:'data-table-expand', text: '', sortable: false}
      ],
      fieldsColumns: [
        { value: 'label', text: 'Campo', sortable: false },
        { value: 'extended_value', text: 'Valor', sortable: false },
      ],
      evidencesColumns: [
        { value: 'mimetype', text: 'Tipo', sortable: false },
        { value: 'title', text: 'Titulo', sortable: false },        
        { value: 'creation_date', text: 'F. Creación', sortable: false },
        {
          value: 'modification_date',
          text: 'F. Modificación',
          sortable: false,
        },
        {
          value: 'version',
          text: 'Version',
          sortable: false,
        },
        { value: 'actions',
          text: 'Actions',
          sortable: false
        },
      ],
      addUnitBussinessProcess: '',
      addUnitParentProcess: '',
      business_process_name:'',
      disableAdddModalButtons: false,
      disableTransitionModalButtons: false,
      tabs: null,
      files: {
        pdf: {
          icon: 'mdi-file-pdf-box',
          color: '#b30b00'
        },
        xls: {
          icon: 'mdi-file-excel',
          color: '#207345'
        },
        msword: {
          icon:  'mdi-file-word',
          color: '#2b569a',
        },
        pptx: {
          icon: 'mdi-file-powerpoint',
          color: '#d24625'
        },
        image:{
          icon:  'mdi-file-image',
          color: '#753c8f'
        },
        video:{
          icon: 'mdi-file-video',
          color: '#f7a42f'
        },
        file: {
          icon: 'mdi-file',
          color: '#0e85cd'
        },
      },
      alert: '',
      // New fields
      showModalDialog: false,
      valid: null,
      loading: false,
      addModalDialog: null,
      modal_title:'',
      submit_button_caption:'',
    }
  },
  computed: {
    sort_icon() {
      return this.unitsSortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending'
    },
    ...mapGetters(['isAdmin']),
    ...mapState([
      'sitePath',
      'isLoading',
      'message',
      'sites',
      'units',
      'unitsCount',
      'unitsItemsPerPage',
      'unitColumns',
      'current_business_process',
      'current_unit',
      'current_parent_process',
      'searchText',
      'allStandards',
      'filteredProcesses',
      'currentStandardID',
      'processID',
      'context_title',
      'current_business_process_name',
      'current_page_number',
      'table_selected',
      'filterFormData',
      'filterDirectory',
      'activeDirectory',
      'explorer_sort_by',
      'explorer_sort_desc',
    ]),
  },
  mounted: function() {
    this.SET_BUSINESS_PROCESS(this.$route.query.business_process)
    let pk =  this.$route.query.pk
      ? this.$route.query.pk
      : ''
    if (this.$auth.isAuthenticated() && this.$session.exists('user')) {
      // On reload get BP from querystring
      this.EXPLORE_UNITS({
        site: this.sitePath,
        bp_reference: this.current_business_process,
        process_id: this.processID,
        search_text: this.searchText,
        filters_form: this.filterFormData,
        filter_directory: this.filterDirectory.id,
        units_page: this.unitsPage,
        units_sort_by: this.unitsSortBy,
        units_sort_desc: this.unitsSortDesc,
        pk: pk
      })
    }
  },
  updated: function() {
    if (this.jsdata) {
      var jsscript = document.createElement('script')
      jsscript.innerText = this.jsdata
      document.head.appendChild(jsscript)
    }
    this.unitsPage = this.current_page_number
  },
  // Watch current route change to reload BP
  watch: {
    $route(to, _from) {
      this.jsdata = ''
      this.SET_BUSINESS_PROCESS(to.query.business_process)
      let pk = to.query.pk
      this.EXPLORE_UNITS({
        site: this.sitePath,
        bp_reference: this.current_business_process,
        process_id: this.processID,
        search_text: this.search,
        filters_form: this.filterFormData,
        filter_directory: this.filterDirectory,
        units_page: this.unitsPage,
        units_sort_by: this.unitsSortBy,
        units_sort_desc: this.unitsSortDesc,
        pk: pk
      })
    },
    filterDirectory() {
      // Apply filter directory when it changes
      this.updateQUnitsPagination();
    }
  },
  methods: {
    addUnit(business_process, parent_qunit_id) {
      // Collect data to creation form
      this.creation_form_error_message = ''
      parent_qunit_id = parent_qunit_id || ''
      if (!business_process) {
        business_process = this.current_business_process
      }
      if (business_process) {
        QUnit.getFieldsToCollectDuringCreation(
          this.sitePath, business_process, parent_qunit_id)
          .then(data => {
            this.fields_to_collect = data['fields']
            // this.creation_fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.addUnitBussinessProcess = business_process
            this.addUnitParentProcess = parent_qunit_id
            this.business_process_name = data['business_process_name']
            this.addModalDialog = true
            this.showModalDialog = true
            // TODO:Lang
            this.modal_title = 'Add new ' + this.business_process_name
            this.submit_button_caption = 'Add'
          })
          .catch(
            error =>
              (this.creation_form_error_message =
                error.body || error.response.data),
          )
      } else {
        this.creation_form_error_message = 'no business_process provided!'
        // this.showAddModalDialog = true
      } 
    },
    submitAddUnit(form_data) {
      let current_item_uid = this.current_unit['uid']
      this.$root.$loader.show('Sending...',{})
      QUnit.createUnit(this.sitePath, form_data)
        .then(data => {
          this.selected = [data]
          if (this.addUnitBussinessProcess == this.current_business_process){
            current_item_uid = data.uid
          }
          this.toggle_dialog()
          this.$root.$loader.hide()
          this.EXPLORE_UNITS({
            site: this.sitePath,
            bp_reference: this.current_business_process,
            process_id: this.processID,
            search_text: this.search,
            filters_form: this.filterFormData,
            filter_directory: this.filterDirectory,
            units_page: this.unitsPage,
            units_sort_by: this.unitsSortBy,
            units_sort_desc: this.unitsSortDesc,
            pk: current_item_uid,
          })          
        })
        .catch(error =>{
            (this.creation_form_error_message =
              error.body || error);
            this.disableAdddModalButtons=false
        })
    }, 
    performTransition(unit, transition) {
      this.SET_CURRENT_UNIT(unit)
      this.form_error_message = ''
      if (transition['related_business_process']) {
        this.addUnit(
          transition['related_business_process'],
          this.current_unit['uid'],
        )
      } else {
        QUnit.getFieldsToCollectDuringTransition(
          this.sitePath,
          this.current_unit['uid'],
          transition['id'],
        )
          .then(data => {
            console.log(data['fields'])
            this.creation_fields_to_collect = []
            this.fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.current_transition = transition
            // this.$refs.transmodal.show()
            this.showModalDialog = true
            this.addModalDialog = false
            // TODO:Lang
            this.modal_title = this.current_transition.label
            this.submit_button_caption = 'Save'
          })
        .catch(
          error =>{
            (this.form_error_message = error.body || error.response.data);
        })
     }
    },
    submitTransition(form_data) {
      let current_item_uid = this.current_unit['uid']
      var new_items = []
      // form_data.append('transition_id', this.current_transition.id);
      this.$root.$loader.show('Sending...',{})
      QUnit.executeTransition(
        this.sitePath,
        this.current_unit['uid'],
        form_data,
      )
        .then(data => {
          for (var i=0; i<this.units.length;i++){
            var item = this.units[i]
            if (item.uid == current_item_uid){
                item = data                
                this.SET_TABLE_SELECTED([item])
            }
            new_items.push(item)
          }
          this.UPDATE_UNITS_TABLE({new_units:new_items})
          this.toggle_dialog()
          this.$root.$loader.hide()
        })
        .catch(
          error =>{
            (this.form_error_message = error.body || error.response.data);
        })        
    },
    updateQUnitsPagination(page) {
      if (page) {
        this.unitsPage = page
      }
      if (this.$auth.isAuthenticated() && this.$session.exists('user')) {
        this.EXPLORE_UNITS({
          site: this.sitePath,
          bp_reference: this.current_business_process,
          process_id: this.processID,
          search_text: this.search,
          filters_form: this.filterFormData,
          filter_directory: this.filterDirectory,
          units_page: this.unitsPage,
          units_sort_by: this.unitsSortBy,
          units_sort_desc: this.unitsSortDesc,
        })
      }
    },
    updateItemsPerPage(items_per_page){
      this.itemsPerPage = items_per_page
    },
    downloadFile(data, filename) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([data.data], {type: 'application/vnd'})

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const ob = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = ob
        link.download = filename //+ '.docx'
        link.click()
        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(ob)
        }, 100)
    }, 
    printItem(item, template){
      QReport.printQUnit(
          this.sitePath,
          item.uid,
          template
      ).then(data => {
        console.log(data)
        let f_name = item.title + '.docx' || item.title + '.docx'
        this.downloadFile(data, f_name)
      }).catch(error => 
        console.log(error)
      )
    },
    printCustomReport(item, template_file){
      // TODO:
      console.log(item.uid, template_file.name)
      QReport.printQUnitCustomTemplate(
          this.sitePath,
          item.uid,
          template_file
      ).then(data => {
        console.log(data)
        let f_name = item.title + '.docx'
        this.downloadFile(data, f_name)
      }).catch(error => 
        console.log(error)
      )
    },
    pdfViewerItem(item, template){
      this.$router.push({ path: 'pdf', query: { uid: item.uid, template: template }});
    },
    handleEvidence(row){
      console.log(row)
      QUnit.getQUnitFile(
        this.sitePath,
        row.qunit_id,
        row.attribute,
        row.value
      ).then(data =>{
        this.downloadFile(data, row.title)
      }).catch(error =>
        console.log('handleEvidence', error)
      )
    },
    childFormSubmit(current_unit){
      var new_items = []
      QUnit.getQUnit(
        this.sitePath,
        current_unit['uid']
      ).then(data =>{
        for (var i=0; i<this.units.length;i++){
          var item = this.units[i]
          if (item.uid == current_unit['uid']){
            item = data
            this.SET_TABLE_SELECTED([item])
          }
          new_items.push(item)
        }
        this.UPDATE_UNITS_TABLE({new_units:new_items})
      }).catch(error =>
        console.log('childFormSubmit', error)
      )
    },
    ...mapActions(['GET_ALL_SITES', 'EXPLORE_UNITS', 'OPEN_UNIT','UPDATE_UNITS_TABLE']),
    ...mapMutations([
      'SET_CURRENT_SITE',
      'SET_USER',
      'SET_MESSAGE',
      'SET_BUSINESS_PROCESS',
      'SET_PARENT_PROCESS',
      'SET_CURRENT_UNIT',
      'SET_CONTEXT_TITLE',
      'SET_TABLE_SELECTED',
    ]),

    getNoDataMessage(){
      if (this.message) {
        if (this.message.response){
          if (this.message.response.data){
            return this.message.response.data
          }
        }
        else{
          if (typeof this.message === 'string'){
            return this.message
          }

        }
      }
      return 'No data available'
      
    },
    // NEW methods
    clear: function() {
       this.$refs.transitionForm.clear();
       this.alert = false
     },
     close: function() {
       this.clear()
       this.addUnitBussinessProcess = ''
       this.addUnitParentProcess = ''
       this.fields_to_collect = []
       this.creation_fields_to_collect = []
       this.showModalDialog = false
       this.valid = true
       this.disable = false
     },
     clearAddForm: function() {
       this.$refs.creationform.clear()
       this.alert = false
     },
     closeAddForm: function() {
       this.clearAddForm()
       this.addUnitBussinessProcess = ''
       this.addUnitParentProcess = ''
       this.fields_to_collect = []
       this.creation_fields_to_collect = []
       this.showAddModalDialog = false
       this.valid = true
       this.disable = false
     },
     toggle_dialog() {
      this.addUnitBussinessProcess = ''
      this.addUnitParentProcess = ''
      this.fields_to_collect = []
      this.creation_fields_to_collect = []
      this.showModalDialog = false
      this.addModalDialog = null
      // this.$root.$loader.hide('I completed some action! Yay!', { timeout: 5000, location: 'top' }, () => { console.log( 'Callback after snackbar hidden' ) })
    },
    process_form: function (form_data) {
      
      console.log('Explorer, form submit', form_data)
      form_data.append('business_process', this.addUnitBussinessProcess)
      form_data.append('parent_process', this.addUnitParentProcess)
      if (this.addModalDialog) {
        console.log('Perform add QUnit')
        this.submitAddUnit(form_data)        
      }else{
        console.log('Perform Transition')
        form_data.append('transition_id', this.current_transition.id)
        this.submitTransition(form_data)
      }
      // this.$root.$loader.hide()
    },
    copyToClipboard(textToCopy)  {
        // let textToCopy = this.current_qunit.uid
        navigator.clipboard.writeText(textToCopy)
    },
  },
}
</script>


<style lang="scss">
    @import "@/sass/explorer.scss";
</style>
